import RadioGroup from '../src/RadioGroup.vue'

export default RadioGroup
